import * as React from 'react';
// Bootstrap / Components
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import InputItem from '../../components/it_operations/client_management/ClientManagementCard';
import { Card, InputGroup, Button, Spinner } from 'react-bootstrap';
import IconButton from '../../components/common/IconButton';
//@ts-ignore
//!!r-18-dj
import { useParams, Link, useHistory } from 'react-router-dom';
import Loader from '../../components/common/Loader';
import Select from 'react-select';
import ErrorAlert from '../../components/common/ErrorAlert';
// Other
import axios from 'axios';
import AxiosConfig from '../../utilities/AxiosConfig';
import moment from 'moment';
import { connect } from 'react-redux';
import { AppState } from '../../store';
import logger from '../../utilities/logging';
import ClipboardIcon from '../../components/common/ClipboardIcon';
import InfoButton from '../../components/common/InfoButton';
import ErrorBoundary from '../../components/common/ErrorBoundary';
import QuerySelect from '../../components/it_operations/client_management/QuerySelect';
import Dialog from '../../utilities/Dialog';
import LeaveRouteGuard from '../../components/common/LeaveRouteGuard';

const activationMessage = "Warning! Client secret detected. If this client is intended for external service access to the portal API, then an activation password is required. Password can by any non-blank string of length greater than 0. Password can be supplied at a later date. Access to API will be blocked until password is present. Would you like to continue anyways?"

export interface EditClientProps {
    username : string
}

export type ClientItem = {
    PortalClientId : string,
    Secret : string | null,
    Description : string | null,
    TokenLifetimeSeconds : number | null,
    AllowedOrigin : string,
    ActivationPwd : string | null,
    CreatedDate : Date | null,
    CreatedBy : string | null,
    ModifyDate : Date | null,
    ModifiedBy : string | null,
    DeletedDate : Date | null,
    DeletedBy : string | null,
    DisabledDate : Date | null,
    DisabledBy : string | null,
    DisabledMessage : string | null,
    MaxRequestsSecond : number,
    MaxRequestsMinute : number,
    MaxRequestsHour : number,
    MaxRequestsDay : number,
    MaxRequestsWeek : number,
    FailedAuthLockoutThreshold : number,
    FailedAuthLockoutPeriodMins : number,
    CustomerId : number | null,
    PortalClientPK: number | null
}

const arrayToObject = (array: Array<any>, keyField: "id" | "text", valueField : string = "") =>
array.reduce((obj: any, item: any) => {
    if(valueField){
        obj[item[keyField]] = item[valueField];
    }else{
        obj[item[keyField]] = item
    }
    return obj
}, {});

const EditClient: React.FC<EditClientProps> = (props: EditClientProps) => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState({         
        PortalClientId : "",
        Secret : "",
        Description :  "",
        TokenLifetimeSeconds :  "",
        AllowedOrigin : "",
        ActivationPwd : "",
        CreatedDate : "",
        CreatedBy :  "",
        ModifyDate : "",
        ModifiedBy : props.username,
        DeletedDate : "",
        DeletedBy :"",
        DisabledDate : "",
        DisabledBy :  "",
        DisabledMessage :  "",
        MaxRequestsSecond : 0,
        MaxRequestsMinute : 0,
        MaxRequestsHour : 0,
        MaxRequestsDay : 0,
        MaxRequestsWeek : 0,
        FailedAuthLockoutThreshold : 0,
        FailedAuthLockoutPeriodMins : 0,
        CustomerId :  "",
        PortalClientPK: 0,
        Roles : [] 
    });
    const [isGenerating, setIsGenerating] = React.useState(false);
    const [edits, setEdits] = React.useState({
        PortalClientId : "",
        Secret : "",
        Description :  "",
        TokenLifetimeSeconds :  "",
        AllowedOrigin : "",
        ActivationPwd : "",
        CreatedDate : "",
        CreatedBy :  "",
        ModifyDate : "",
        ModifiedBy : "",
        DeletedDate : "",
        DeletedBy :"",
        DisabledDate : "",
        DisabledBy :  "",
        DisabledMessage :  "",
        MaxRequestsSecond : 0,
        MaxRequestsMinute : 0,
        MaxRequestsHour : 0,
        MaxRequestsDay : 0,
        MaxRequestsWeek : 0,
        FailedAuthLockoutThreshold : 0,
        FailedAuthLockoutPeriodMins : 0,
        CustomerId :  "",
        Roles : []
    });
    const [validated, setValidated] = React.useState(false);
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [savingError, setSavingError] = React.useState(false);
    const [getClientError, setGetClientError] = React.useState(false);
    const [isDeleting, setIsDeleting] = React.useState(false);
    const [customerIds, setCustomerIds]: any = React.useState({});
    const [loadingRoles, setLoadingRoles] = React.useState(false);
    const [roles, setRoles] = React.useState([]);
    const [clientRoles, setClientRoles] = React.useState([]);
    const [getRolesError, setGetRolesError] = React.useState(false);
    const [isFormChanged, setIsFormChanged] = React.useState(false);
    const [queryEditRequests, setQueryEditRequests] = React.useState([]);

    const p: any = useParams();
    let history = useHistory();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        e.preventDefault();
        let final = {
            ...edits,
            [e.target.name] : e.target.value
        }
        setEdits(final);
        checkForChanges(final);
    }

    const checkForChanges = (e: any) => {
        let d:any = {...data};
        let form: any = document.getElementById("editClientForm");
        if(form){
            form.checkValidity();
        }
        for(const property in d){
            let dProp = d[property] === null ? "" : d[property]?.toString()
            if(dProp !== e[property]?.toString()){
                setIsFormChanged(true);
                return true;
            }
        }
        if(clientRoles.map((item:any) => item.value) !== d.Roles){
            setIsFormChanged(true);
            return true;
        }
        setIsFormChanged(false);
        if(queryEditRequests.length > 0){
            setIsFormChanged(true);
            return true;
        }
        return false;
    }

    const generateSecret = (e: React.SyntheticEvent) => {
        e.preventDefault();
        setIsGenerating(true);
        axios.get(process.env.REACT_APP_API_URL + `/api/portal/clientsecret/${edits.PortalClientId}`, AxiosConfig.configValue("min"))
        .then(response => {
            let final = {
                ...edits,
                Secret : response.data
            }
            setEdits(final);
            checkForChanges(final);
            //console.log(response, response.data);
        })
        .catch(error => {
            //console.log(error);
            //console.log(error.response);
            alert("There was an error generating a key. Please try again");
            logger.Error({
                EventMessage : "EditClient -> generateSecret -> Error :" + JSON.stringify(error.response),
                EventCategory : "httprequest"
            });
        })
        .finally(() => {
            setIsGenerating(false);
        })
    }

    const submitEdits = async (e: any) => {
        setIsSubmitting(true);
        //console.log("Submitting Edits");
        e.preventDefault();
        const form: any = e?.currentTarget;
        //console.log(form.checkValidity());
        if(queryEditRequests.length){
            queryEditRequests.forEach(async (req: any) => {
                await axios.post(process.env.REACT_APP_API_URL + "/api/UpdateClientQueryType", req, AxiosConfig.configValue("min"))
                .then((res: any) => {
                    //console.log(res);
                })
                .catch((err: any) => {
                    //console.log(err);
                })
            })
        }
        if(form.checkValidity() === false){
            //console.log("Check Validity Returned False");
            e.preventDefault();
            e.stopPropagation();
            setIsSubmitting(false);
        }else{
            // alert("Passed Validation. Request in console.");
            //console.log("Form Values", edits);
            let final = {
                ...edits,
                DisabledBy : edits.DisabledBy ? edits.DisabledBy : null,
                DisabledDate : edits.DisabledDate ? edits.DisabledDate : null,
                TokenLifetimeSeconds :  Number(edits.TokenLifetimeSeconds),
                MaxRequestsSecond : Number(edits.MaxRequestsSecond),
                MaxRequestsMinute : Number(edits.MaxRequestsMinute),
                MaxRequestsHour : Number(edits.MaxRequestsHour),
                MaxRequestsDay : Number(edits.MaxRequestsDay),
                MaxRequestsWeek : Number(edits.MaxRequestsWeek),
                FailedAuthLockoutThreshold : Number(edits.FailedAuthLockoutThreshold),
                FailedAuthLockoutPeriodMins : Number(edits.FailedAuthLockoutPeriodMins),
                Roles : clientRoles.map((item: any) => item.value)
            }
            //console.log("Form values after fixing", final);
            let confirm = true;
            if(edits.Secret && !edits.ActivationPwd){
                let c: any = new Dialog({ message: activationMessage });
                confirm = await c.show();
            }
            if(confirm){
                axios.post(process.env.REACT_APP_API_URL + "/api/portal/client", final, AxiosConfig.configValue("min"))
                .then(response => {
                    //console.log(response);
                    setData(response.data);
                    setEdits(response.data);
                    setSavingError(false);
                    setIsFormChanged(false);
                })
                .catch(error => {
                    let e = error.response;
                    //console.log(e);
                    if(e && e.status){
                        AxiosConfig.handleError(e.status);
                    }
                    setSavingError(true);
                    logger.Error({
                        EventMessage : "EditClient -> submitEdits -> Error :" + JSON.stringify(error.response),
                        EventCategory : "httprequest"
                    });
                })
                .finally(() => {
                    setIsSubmitting(false);
                })
            }else{
                setIsSubmitting(false);
            }
        }
        setValidated(true);
    }

    const toggleDisabled = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        // let originallyDisabled = false;
        // if(data.DisabledDate || data.DisabledBy){
        //     originallyDisabled = true;
        // }
        const final = {
            ...edits,
            DisabledDate : edits.DisabledDate ? "" : moment().toISOString(),
            DisabledMessage : edits.DisabledMessage || "",
            DisabledBy : edits.DisabledBy ? "" : props.username
        };
        //console.log(final);
        setEdits(final);
        checkForChanges(final);
        alert("You must save to apply to these changes.")
    }

    const getClient = () => {
        setLoading(true);
        let id:string = p.id
        if(id){
            axios.get(`${process.env.REACT_APP_API_URL}/api/portal/client/${id}`, AxiosConfig.configValue("min"))
            .then(response => {
                //console.log("response from edit client", response);
                if(response.data){
                    //console.log("Response from Edit Client", response.data);
                    setData(response.data.client);
                    setEdits(response.data.client);
                    setClientRoles(response.data.client.Roles.map((role: string) => ({ value : role, label : role })))
                    // const customerList: any = createOptionsList(response.data.reference);
                    const cl: any = arrayToObject(response.data.reference, "id", "text");
                    //console.log(cl);
                    // //console.log("this is the customer list", customerList)
                    setCustomerIds(cl);
                    setGetClientError(false);
                }else{
                    setGetClientError(true);
                }
            })
            .catch(error => {
                //console.log(error, error.response);
                setGetClientError(true);
                logger.Error({
                    EventMessage : "EditClient -> getClient -> Error :" + JSON.stringify(error.response),
                    EventCategory : "httprequest"
                });
            })
            .finally(() => {
                setLoading(false);
            })
        }
    }

    const deleteClient = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        let c: any = new Dialog({ message: `Are you sure you want to delete ${p.id}?` });
        let answer: boolean = await c.show();
        if(answer){
            setIsDeleting(true);
            let rb = {
                ...data,
                DeletedDate : moment().toISOString(),
                DeletedBy : props.username
            };
            axios.post(process.env.REACT_APP_API_URL + "/api/portal/client", rb, AxiosConfig.configValue("min"))
            .then(response => {
                //console.log(response);
                history.push("/it/client-management");
            })
            .catch(error => {
                //console.log(error, error.response);
                logger.Error({
                    EventMessage : "EditClient -> deleteClient -> Error :" + JSON.stringify(error.response),
                    EventCategory : "httprequest"
                });
            })
            .finally(() => {
                setIsDeleting(false);
            })
        }
    }

    const getAvailableRoles = () => {
        setLoadingRoles(true);
        axios.get(process.env.REACT_APP_API_URL + '/api/portal/role/*', AxiosConfig.configValue("min"))
        .then(res => {
            //console.log("response from getAvailable roles", res);
            let final:any = [];
            res.data.forEach((role: any) => {
                final.push({
                    label : role.RoleName,
                    value : role.RoleName
                });
            });
            //console.log("Final Object", final);
            setRoles(final);
            setGetRolesError(false);
        })
        .catch(err => {
            //console.log(err, err.response);
            setGetRolesError(true);
            logger.Error({
                EventMessage : "EditClient -> getAvailableRoles -> Error :" + JSON.stringify(err?.response),
                EventCategory : "httprequest"
            });
        })
        .finally(() => {
            setLoadingRoles(false);
        })
    }

    const clearSecret = (e: React.SyntheticEvent) => {
        e.preventDefault();
        setEdits({...edits, Secret : ""});
        checkForChanges({...edits, Secret : ""});
    }

    const queryChangeHandler = (editRequests: any) => {
        //console.log("Query Change Handler", editRequests);
        setQueryEditRequests(editRequests);
        checkForChanges(edits);
    }

    React.useEffect(() => {
        getClient();
        getAvailableRoles();
        // getTicketTypes();
        // eslint-disable-next-line 
    }, [])

    return(
        <ErrorBoundary errorMessage="There was a critical error loading this page." showError={true}>
        <LeaveRouteGuard when={isFormChanged} message="Are you sure you want to leave? All unsaved changes will be lost" /> 
        <Col sm className="mb-5">
            <Container fluid className="h-100 no-vertical" style={{ maxHeight : "calc(100vh - 48px)", overflowY : "scroll" }}>
                <Link to="/it/client-management">
                    <i className="material-icons">undo</i>
                    Back to Clients
                </Link>
                <ErrorAlert show={getClientError} >
                    There was an error getting {p.id} data.
                    <span className="action-icon cursor-on-hover" onClick={getClient}> Try Again?</span>
                </ErrorAlert>
                <ErrorAlert show={savingError} >
                    There was an error saving your edits. Please make sure all fields are valid and try again.
                </ErrorAlert>
                <ErrorAlert show={getRolesError}>
                    There was an error recieving available roles. <span onClick={(e: React.SyntheticEvent) => {
                        e.preventDefault();
                        getAvailableRoles();
                    }}>Try Again?</span>
                </ErrorAlert>
                {
                loading || loadingRoles
                ?
                <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                    <Loader title={`Loading ${p?.id} data`} />
                </div>
                :
                <Form id="editClientForm" noValidate validated={validated} onSubmit={submitEdits} className="w-100 d-flex flex-row flex-wrap justify-content-center align-items-center">
                    <Col className="border border-right-0 border-left-0 border-top-0 d-flex justify-content-between mt-3 align-items-center mb-2 d-flex flex-column flex-md-row" sm={12}>
                        <h5>Basic Information</h5>
                        <div className="d-flex flex-column flex-md-row">
                            {
                            (edits.DisabledBy && edits.DisabledDate)
                            ? <IconButton onClick={toggleDisabled} name="IsDisabled" buttonClassName="btn-success" icon="autorenew">Enable Client</IconButton> 
                            : <IconButton onClick={toggleDisabled} name="IsDisabled" buttonClassName="btn-secondary" icon="not_interested">Disable Client</IconButton>
                            }
                            <IconButton showSpinner={isDeleting} onClick={deleteClient} buttonClassName="btn-danger mx-2" icon="delete">Delete Client</IconButton>
                            <IconButton 
                                disabled={loading || loadingRoles || !isFormChanged} 
                                showSpinner={isSubmitting} 
                                buttonClassName="btn-primary" 
                                type="submit" 
                                icon="save"
                            >
                                Save Changes
                            </IconButton>
                        </div>
                    </Col>
                    <InputItem readOnly onChange={handleChange} name="PortalClientId" label="Client Id:" type="text" value={edits.PortalClientId} />
                    <Card.Text as={Col} sm="12" md="6" className="d-flex">
                        <Form.Group className="w-100" as={Row}>
                            <Form.Label column sm="4">
                                Secret :
                                <ClipboardIcon className="my-auto ml-1" text={edits.Secret || ""} />
                            </Form.Label>
                                <Col sm="8">
                                    <InputGroup>
                                        <Form.Control onChange={(e: any) => false} name="Secret" value={edits.Secret || ""} />
                                        <InputGroup.Append className="d-flex justify-content-center align-items-center">
                                            {
                                                edits.Secret 
                                                ?<Button 
                                                    onClick={clearSecret} 
                                                    variant="secondary"
                                                    title="Clear Secret"
                                                >
                                                    <span className="d-flex align-items-center justify-content-center">
                                                        <i className="material-icons">clear</i>
                                                    </span>
                                                </Button>
                                                :<Button 
                                                    disabled={isGenerating} 
                                                    onClick={generateSecret} 
                                                    variant="secondary"
                                                    title="Generate Key"
                                                >
                                                    { 
                                                    isGenerating 
                                                    ? <Spinner size="sm" animation="border" role="status" /> 
                                                    : <span className="d-flex align-items-center justify-content-center"><i className="material-icons">vpn_key</i></span>
                                                    }
                                                </Button>
                                            }
                                        </InputGroup.Append>
                                    </InputGroup>
                                </Col>
                        </Form.Group>
                    </Card.Text>
                    <InputItem readOnly name="CustomerId" label="Customer :" type="text" defaultValue={customerIds ? customerIds[edits.CustomerId] : edits.CustomerId} />
                    <InputItem required min="-1" onChange={handleChange} name="TokenLifetimeSeconds" label="Token Lifetime Seconds :" type="number" value={edits.TokenLifetimeSeconds}/>
                    <InputItem required onChange={handleChange} name="AllowedOrigin" label="Allowed Origin : " type="text" value={edits.AllowedOrigin || ""} /> 
                    <InputItem onChange={handleChange} name="Description" label="Description :" type="text" value={edits.Description || ""} />
                    <InputItem 
                        data-private 
                        onChange={handleChange} 
                        name="ActivationPwd" 
                        label="Activation Password :" 
                        type="text" 
                        value={edits.ActivationPwd || ""}
                    >
                    {
                        (edits.Secret && !edits.ActivationPwd)&&
                        <InfoButton variant="warning" type="warning" id="activation-info">
                            Client secret detected. If this client is intended for external service access to the portal API, then an activation password is required.
                        </InfoButton>
                    }
                    </InputItem>
                    <InputItem maxLength={400} name="DisabledMessage" disabled={edits.DisabledDate ? false : true} onChange={handleChange} label="Disabled Message :" type="text" value={edits.DisabledMessage || ""} /> 
                    <Col className="border border-right-0 border-left-0 border-top-0 mt-3 mb-2" sm={12}>
                        <h5>Lockout Rules</h5>
                    </Col>
                    <InputItem min={0} required name="FailedAuthLockoutPeriodMins" onChange={handleChange} label="Failed Auth Lockout Period Mins :" type="number" value={edits.FailedAuthLockoutPeriodMins || ""} /> 
                    <InputItem min={0} required name="FailedAuthLockoutThreshold" onChange={handleChange} label="Failed Auth Lockout Threshold :" type="number" value={edits.FailedAuthLockoutThreshold || ""} /> 
                    <Col className="border border-right-0 border-left-0 border-top-0 mt-3 mb-2" sm={12}>
                        <h5>Max Requests</h5>
                    </Col>
                    <InputItem min={0} name="MaxRequestsDay" onChange={handleChange} label="Max Requests Day :" type="number" value={edits.MaxRequestsDay} /> 
                    <InputItem min={0} name="MaxRequestsHour" onChange={handleChange} label="Max Requests Hour" type="number" value={edits.MaxRequestsHour} />
                    <InputItem min={0} name="MaxRequestsMinute" onChange={handleChange} label="Max Requests Minute :" type="number" value={edits.MaxRequestsMinute} /> 
                    <InputItem min={0} name="MaxRequestsSecond" onChange={handleChange} label="Max Requests Second :" type="number" value={edits.MaxRequestsSecond} /> 
                    <InputItem wrapperClassName="mr-auto" min={0} name="MaxRequestsWeek" onChange={handleChange} label="Max Requests Week :" type="number" value={edits.MaxRequestsWeek} />
                    <Col className="border border-right-0 border-left-0 border-top-0 mt-3 mb-2" sm={12}>
                        <h5>Client Roles</h5>
                    </Col>
                    <Select
                        name="Roles" 
                        options={roles}
                        value={clientRoles}
                        className="w-100"
                        isMulti
                        onChange={(selection: any) => {
                            //console.log("Selection", selection);
                            setClientRoles(selection || []);
                            let f = selection ? selection.map((item:any) => item.value) : [];
                            checkForChanges({...edits, Roles : f});
                        }}
                        isDisabled={loadingRoles}
                        isLoading={loadingRoles}
                    />
                    <Col className="border border-right-0 border-left-0 border-top-0 mt-3" sm={12}>
                        <h5>Query Permissions</h5>
                    </Col>
                    <QuerySelect changeCallback={queryChangeHandler} portalClientPK={data.PortalClientPK} clientId={data.PortalClientId}/>
                </Form>
                }
            </Container>
        </Col>
        </ErrorBoundary>
    );
}

const mapStateToProps = (state : AppState) => ({ username : state.user.userName });

export default connect(mapStateToProps, {})(EditClient)